// @flow
'use strict';

import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import type { IProdutoServico } from '../../../types';

import DadosBasicos from './dados_basicos';
import Imposto from './imposto';
import IbsCbsEImpostoSeletivo from '../../../../../common/detalhes_documento/ibs_cbs_e_imposto_seletivo/ibs_cbs_e_imposto_seletivo';
import RowDetalhes from '../../../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../../../common/detalhes_documento/column_detalhes';

type ModalProps = {
  open : bool,
  fechaModal : ()  => void,
  item : IProdutoServico,
}

export default function ModalDetalhes({ open, fechaModal, item } : ModalProps) {
  const titulo = `Detalhes do Item ${ item.item }: ${ item.descricao }`;

  return (
      <Modal show={ open } onHide={ fechaModal } dialogClassName="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>{ titulo }</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <section className="visualizacao-documento">
            <DadosBasicos item={ item }/>
            <Imposto item={ item.imposto }/>
            <IbsCbsEImpostoSeletivo ibsCbsEImpostoSeletivo={ item.ibsCbsEImpostoSeletivo }/>

            <h3>Total do Item da NFe</h3>
            <RowDetalhes data={ item } className="no-margin-bottom">
              <ColumnDetalhes field="valorTotalItemNfe" type="moeda">Valor total do item da NFe</ColumnDetalhes>
            </RowDetalhes>

            <h3>Documento Referenciado</h3>
            <RowDetalhes data={ item } className="no-margin-bottom">
              <ColumnDetalhes field="chaveDfeReferenciado">Chave do DF-e referenciado</ColumnDetalhes>
              <ColumnDetalhes field="itemReferenciado">Item referenciado</ColumnDetalhes>
            </RowDetalhes>
          </section>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={ fechaModal }>Fechar</Button>
        </Modal.Footer>
      </Modal>
  );
}